import React from 'react';
import { observer } from 'mobx-react-lite';
import { generalStore } from '../../store';
import { FiWifiOff } from 'react-icons/fi';

const InternetMessage: React.FC = observer(() => {
  if (generalStore.isInternet) return null;

  return (
    <div className="bg-red-500 text-white px-4 py-2 flex items-center justify-center gap-2 safe-area-top">
      <FiWifiOff className="w-4 h-4" />
      <span className="text-xs font-medium">No Internet Connection</span>
    </div>
  );
});

export default InternetMessage;
